import * as Tone from 'tone';

// Stereo chorus. Tone.Chorus needs .start() before its LFO ticks; without it
// the depth is silent.

export default {
    id: 'chorus',
    name: 'Chor',
    color: '#98c379',
    create() {
        const node = new Tone.Chorus({
            frequency: 1.5, delayTime: 3.5, depth: 0.7, type: 'sine', spread: 180, wet: 0.7,
        }).start();
        return {
            node,
            params: [
                { label: 'Rate', unit: 'Hz', min: 0.1, max: 8, step: 0.05,
                  get: () => node.frequency.value, set: v => { node.frequency.value = v; } },
                { label: 'Depth', min: 0, max: 1, step: 0.01,
                  get: () => node.depth, set: v => { node.depth = v; } },
                { label: 'Wet', min: 0, max: 1, step: 0.01,
                  get: () => node.wet.value, set: v => { node.wet.value = v; } },
            ],
            dispose() { node.dispose(); },
        };
    },
};
